module.exports = {
      id: "hamburger-whatsapp-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#hamburger-whatsapp",
      toString: function () {
        return this.url;
      }
    }